import { Result, ResultVariants } from '@dexma/ui-components';
import { StyledTable } from 'adapter/in/common/components/HomeTable/style';
import Bot from 'asset/images/bot.svg';
import i18n from 'asset/translation';
import React, { memo, ReactElement } from 'react';

export type HomeTableProps = {
    columns: any | null;
    dataSource: any[] | null;
    isLoading: boolean;
    showError: boolean;
    onChange: (
        pagination: never,
        filters: never,
        sorter: { column: { columnKey: string }; order: 'ascend' | 'descend' },
        extra: { currentDataSource: []; action: 'paginate' | 'sort' | 'filter' }
    ) => void;
};

const HomeTable = (props: HomeTableProps): ReactElement => {
    const { columns, dataSource, isLoading, showError, onChange } = props;
    return (
        <StyledTable
            columns={columns}
            dataSource={dataSource?.map((source) => ({ ...source, key: source.id }))}
            isLoading={isLoading}
            showError={showError}
            locale={{
                triggerAsc: i18n.t('dashboards.sort.ascend', { column: i18n.t('common.name') }),
                triggerDesc: i18n.t('dashboards.sort.descend', { column: i18n.t('common.name') }),
            }}
            errorContent={
                <Result
                    variant={ResultVariants.DEFAULT}
                    title={i18n.t('common.errorWrong')}
                    info={i18n.t('common.errorWrongInfo')}
                    iconElement={<Bot />}
                />
            }
            onChange={onChange as any}
        />
    );
};

export default memo(HomeTable);
